import theme from '@vromo/ui/components/theme';
import { css } from 'emotion';

export default {
    container: css`
        height: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
    `,
    contentContainer: css`
        width: 100%;
        display: flex;
        flex-direction: column;
        position: relative;
        flex-shrink: 0;
    `,
    topContent: css`
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 20px;
        padding-bottom: 10px;
        flex-shrink: 0;

        @media (max-width: 500px) {
            flex-direction: column;
            align-items: flex-end;

            button {
                margin: 10px;
            }
        }
    `,
    filtersContainer: css`
        display: flex;
        align-items: center;
        border-radius: 4px;
        color: ${theme.primary};
        padding: 10px;
        margin-right: 10px;
        font-weight: 600;
        border: 1px solid ${theme.primary};
        flex-shrink: 0;
    `,
    filterDateText: css`
        margin-left: 10px;
    `,
    filterButton: css`
        position: relative;
        flex-shrink: 0;
    `,
    filterCount: css`
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: ${theme.danger};
        position: absolute;
        top: -5px;
        right: -5px;
    `
};
